import {NotificationService} from "./NotificationService";
import {environment} from '../../Environments/environment';

export class PwaInstallService {
  static $inject = [
    "$window",
      "$rootScope"
  ];
  static serviceId = "pwaInstall";

  private deferredPrompt: any;
  private isInstallable = false;
  private isIOS = false;
  private isStandalone = false;

  constructor(
    private $window: Window,
    private $rootScope: ng.IRootScopeService,
  ) {
    // Check if the app is running in standalone mode (already installed)
    this.isStandalone = this.$window.matchMedia('(display-mode: standalone)').matches || 
                        (this.$window.navigator as any).standalone || 
                        document.referrer.includes('android-app://');

    // Detect iOS
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

    // Listen for the beforeinstallprompt event
    this.$window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later
      this.deferredPrompt = e;
      this.$rootScope.$applyAsync(()=>{
        this.isInstallable = true;
      });
    });
  }

  /**
   * Check if the app can be installed
   */
  canInstall(): boolean {
    if (environment.showInstallModal) {
      return true;
    }
    return !this.isStandalone && (this.isInstallable || this.isIOS);
  }

  /**
   * Check if the device is running iOS
   */
  isIOSDevice(): boolean {
    if (environment.showInstallModal) {
      return true;
    }
    return this.isIOS;
  }

  /**
   * Show the native install prompt (Android)
   */
  async showInstallPrompt(): Promise<boolean> {
    if (!this.deferredPrompt) {
      return false;
    }

    // Show the install prompt
    this.deferredPrompt.prompt();

    // Wait for the user to respond to the prompt
    const choiceResult = await this.deferredPrompt.userChoice;

    // Clear the saved prompt since it can only be used once
    this.deferredPrompt = null;
    this.isInstallable = false;

    // Return true if the user accepted the installation
    return choiceResult.outcome === 'accepted';
  }

  /**
   * Show iOS installation instructions
   */
  showIOSInstructions(element: HTMLElement): void {
    if (!this.isIOS && !environment.showInstallModal) {
      return;
    }

    // Create overlay element
    const overlay = document.createElement('div');
    overlay.className = 'ios-install-overlay';
    overlay.innerHTML = `
      <div class="ios-install-instructions">
        <h3>App installieren</h3>
        <p>Um diese App auf Ihrem iOS-Gerät zu installieren:</p>
        <ol>
          <li>Tippen Sie auf <strong>Teilen</strong> <span class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
              <polyline points="16 6 12 2 8 6"></polyline>
              <line x1="12" y1="2" x2="12" y2="15"></line>
            </svg>
          </span></li>
          <li>Scrollen Sie nach unten und tippen Sie auf <strong>Zum Home-Bildschirm</strong></li>
          <li>Tippen Sie auf <strong>Hinzufügen</strong></li>
        </ol>
        <button class="close-button">Schliessen</button>
      </div>
    `;

    // Add overlay to the DOM
    document.body.appendChild(overlay);

    // Add event listener to close button
    const closeButton = overlay.querySelector('.close-button');
    closeButton.addEventListener('click', () => {
      document.body.removeChild(overlay);
    });
  }
}
